import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBubbleWide"><Path d="M4.5 3C3.11929 3 2 4.11929 2 5.5V16.5C2 17.8807 3.11928 19 4.49999 19L8.65182 19C8.76928 19 8.883 19.0414 8.97302 19.1168L11.0381 20.8479C11.593 21.313 12.401 21.3154 12.9586 20.8534L15.0569 19.115C15.1466 19.0407 15.2595 19 15.3759 19H19.5C20.8807 19 22 17.8807 22 16.5V5.50002C22 4.11931 20.8807 3.00002 19.5 3.00002L4.5 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleWide;
